import React, { Fragment, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import RincianTandaTerimaModal from "./RincianTandaTerimaModal";
import useAxios from "../../../Utils/useAxios";
import DataTable from "react-data-table-component";
import { customStyles } from "../../DataTableComponents/CustomStyle";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import getTandaTerimaColumns from "../constants/getTandaTerimaColumns";

const TandaTerima = ({ groupDokumenTransaksiList, pending }) => {
  const axiosInstance = useAxios();

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedTandaTerima, setSelectedTandaTerima] = useState(null);
  const toggleEditModal = () => setEditModalOpen(!editModalOpen);

  const [filteredItems, setFilteredItems] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    if (groupDokumenTransaksiList) updateFilter(groupDokumenTransaksiList);
  }, [groupDokumenTransaksiList, filterText]);

  const handleEditTandaTerima = (dokumen) => {
    setSelectedTandaTerima(dokumen);
    toggleEditModal();
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const updateFilter = (items) => {
    const searchCategories = [
      "diajukan_oleh",
      "kode_group_dokumen",
      "username_pic_keuangan",
    ];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );
    setFilteredItems(filteredItems);
  };

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <DataTable
              columns={getTandaTerimaColumns({
                themeContext,
                handleEditTandaTerima,
                axiosInstance
              })}
              data={filteredItems}
              customStyles={customStyles}
              pagination
              subHeader
              subHeaderComponent={
                <FilterComponent
                  onFilter={(e) => {
                    setFilterText(e.target.value);
                  }}
                  onClear={() => handleClear()}
                  filterText={filterText}
                />
              }
              subHeaderAlign="right"
              highlightOnHover
              progressPending={pending}
              persistTableHead
              theme={themeContext}
            />
          </Col>
        </Row>
      </Container>
      {selectedTandaTerima && (
        <RincianTandaTerimaModal
          modalOpen={editModalOpen}
          toggleModal={toggleEditModal}
          selectedTandaTerima={selectedTandaTerima}
          axiosInstance={axiosInstance}
        />
      )}
    </Fragment>
  );
};

export default TandaTerima;
